<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <ng-container>
      <div class="modal-title">
        <span>Sage Class Selection</span>
        <div class="modal-subtitle">Investigation# {{ investigation?.nefcoNumber || investigation?.id }}</div>
      </div>
    </ng-container>
  </kendo-dialog-titlebar>
  <div class="model-body">
    <p>Company class <b>{{ investigation?.BillToBranch?.Company?.name }}</b> is not linked with SAGE. You can either select an
      existing SAGE
      class from the list below or create a new class in SAGE.</p>
    <kendo-gridlayout class="mt-16" [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(5,minmax(0,1fr))']">
      <ng-container *ngFor="let item of sageClasses">
        <kendo-gridlayout-item class="detail radio-item">
          <div class="kendo-radio">
            <input kendoRadioButton [name]="'sageKey'" [(ngModel)]="selectedSageId" type="radio" [value]="item?.id" />
          </div>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item class="detail" [colSpan]="2">
          <span>
            Sage ID
          </span>
          <p>
            {{item?.id}}
          </p>
        </kendo-gridlayout-item>
        <kendo-gridlayout-item class="detail" [colSpan]="2">
          <span>
            Class Name
          </span>
          <p>
            {{item?.name}}
          </p>
        </kendo-gridlayout-item>
      </ng-container>
      <kendo-gridlayout-item class="detail radio-item" [colSpan]="5">
        <div class="kendo-radio">
          <input kendoRadioButton [name]="'sageKey'" #new type="radio" [(ngModel)]="selectedSageId" [value]="'NEW'" />
          <kendo-label class="k-checkbox-label font-weight-600 checkbox-margin" style="margin-bottom: 0" [for]="new"
            text="Create new class in SAGE"></kendo-label>
        </div>
      </kendo-gridlayout-item>
    </kendo-gridlayout>
  </div>
  <kendo-dialog-actions layout="end">
    <button kendoButton [size]="'medium'" themeColor="light" class="mr-16" (click)="close(false)">Cancel</button>
    <button kendoButton [size]="'medium'" themeColor="primary" class="mr-16" [disabled]="!selectedSageId"
      (click)="submit()">Save</button>
  </kendo-dialog-actions>
</div>
